// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"MessageButtonsView_buttonsContainer__f4+St"};